import { render, staticRenderFns } from "./EnacAtplDashboardSkillsProgressTopBox.vue?vue&type=template&id=22297dbe"
import script from "./EnacAtplDashboardSkillsProgressTopBox.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardSkillsProgressTopBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports